import React, { useState, useEffect } from "react";
import { Card, Nav } from "react-bootstrap";
import {
  ApprovalPengakuanPiutang,
  HistoryApprovalPengakuanPiutang,
} from "./Tabs";

const MainApprovalPengakuanPiutang = ({ setNavbarTitle }) => {
  useEffect(() => {
    setNavbarTitle("Approval Pengakuan Piutang");
    return () => {};
  }, []);
  const [tabs, setTabs] = useState("approval"); //State untuk menampung tabs yang aktif

  // Menangani perubahan pada tabs
  const onTabsChangeHandler = (e, newPage) => {
    e.preventDefault();
    setTabs(newPage);
  };

  const TabsNav = ({ tab, label }) => (
    <Nav.Item>
      <Nav.Link href={`#${tab}`} onClick={(e) => onTabsChangeHandler(e, tab)}>
        {label}
      </Nav.Link>
    </Nav.Item>
  );

  return (
    <Card>
      <Card.Header>
        <Nav variant="tabs" defaultActiveKey={`#${tabs}`}>
          <TabsNav tab="approval" label="Approval" />
          <TabsNav tab="history" label="History" />
        </Nav>
      </Card.Header>
      <Card.Body>
        {tabs === "approval" ? (
          <ApprovalPengakuanPiutang />
        ) : (
          <HistoryApprovalPengakuanPiutang />
        )}
      </Card.Body>
    </Card>
  );
};

export default MainApprovalPengakuanPiutang;
